enum MainPageContentRu {
  TITLE = 'Trello помогает собрать всех сотрудников, задачи и инструменты в одном месте',
  TEXT = 'Объедините все в одном месте, даже если участники вашей команды рассеяны по миру.',
  SIGN_UP_BUTTON = 'Зарегистрируйтесь - это бессплатно!',
  LOG_IN_BUTTON = 'Вход',
  LEN_BUTTON = 'Русский',
  CHANGE_LEN = 'English',
}

enum MainPageContentEn {
  TITLE = 'Trello brings all your tasks, teammates, and tools together',
  TEXT = 'Keep everything in the same place—even if your team isn’t.',
  SIGN_UP_BUTTON = 'Sign up - it’s free!',
  LOG_IN_BUTTON = 'Log in',
  LEN_BUTTON = 'Русский',
  CHANGE_LEN = 'English',
}

enum LoginPageContentRu {
  LOGIN_TITLE = 'Вход в Trello',
  INPUT_EMAIL = 'Укажите адрес электронной почты',
  INPUT_PASSWORD = 'Введите пароль',
  LOGIN = 'Войти',
  HAVE_ACCOUNT = 'Не удается войти?',
  REGISTER = 'Зарегистрировать аккаунт',
}

enum LoginPageContentEN {
  LOGIN_TITLE = 'Log in to your account',
  INPUT_EMAIL = 'Input E-mail',
  INPUT_PASSWORD = 'Input password',
  //FORGOT = 'Forgot Your Password?',
  LOGIN = 'Sign In',
  HAVE_ACCOUNT = 'Don’t have an account?',
  REGISTER = 'Register',
}

enum SignUpPageContentRu {
  SIGN_UP_TITLE = 'Регистрация аккаунта',
  INPUT_NAME = 'Укажите ваше имя',
  INPUT_EMAIL = 'Укажите адрес электронной почты',
  INPUT_PASSWORD = 'Введите пароль',
  SIGN_UP = 'Продолжить',
  HAVE_ACCOUNT = 'Уже есть аккаунт?',
  LOGIN = 'Войти',
}

enum SignUpPageContentEn {
  SIGN_UP_TITLE = 'Sign up for your account',
  INPUT_NAME = 'Enter your name',
  INPUT_EMAIL = 'Enter email',
  INPUT_PASSWORD = 'Enter password',
  SIGN_UP = 'Continue',
  HAVE_ACCOUNT = 'Already have an account?',
  LOGIN = 'Log in',
}

enum MenuContentRu {
  MENU_TITLE = 'Рабочее пространство',
  MENU_ITEM_BOARDS = '  Доски',
  MENU_ITEM_MEMBERS = 'Участники',
  MENU_ITEM_SETTINGS = 'Настройки',
  MENU_SUBTITLE = 'Мои доски',
  MENU_VIEWS = 'Режимы просмотра рабочего пространства',
  TABLE_VIEW = 'Таблица',
  CALENDAR_VIEW = 'Календарь',
}

enum MenuContentEn {
  MENU_TITLE = 'Workspaces',
  MENU_ITEM_BOARDS = 'Boards',
  MENU_ITEM_MEMBERS = 'Members',
  MENU_ITEM_SETTINGS = 'Settings',
  MENU_SUBTITLE = 'Your boards',
  MENU_VIEWS = 'Workspace views',
  TABLE_VIEW = 'Table',
  CALENDAR_VIEW = 'Calendar',
}

enum WorkspaceContentRu {
  WORKSPACE_TITLE = 'Untitled',
  BOARDS_TITLE = 'Доски',
  MEMBERS_TITLE = 'Пользователи',
  BOARD_NAME = 'Название доски',
  BOARD_CREATE = 'Создать доску',
  BOARD_COLOR = 'Цвет доски',
  WORKSPACE_ERROR = 'Ошибка',
  WORKSPACE_INVITE = 'Пригласить в воркспейс',
  CREATE = 'Создать',
  WORKSPACE_TITLES = 'Рабочие пространства',
  WORKSPACE_CURRENT = 'Текущее',
  WORKSPACE_CREATE = 'Создать рабочее пространство',
  WORKSPACE_NAME = 'Название рабочего пространства',
  WORKSPACE_COLOR = 'Цвет рабочего пространства',
  UPDATE_WORKSPASE_TITLE = 'Изменить в рабочем пространстве',
  UPDATE_WORKSPASE = 'Название',
  UPDATE_WORKSPASE_NAME = 'Новое имя пространства',
  CHECK_FAVORITE = 'в избранное',
  WORKSPASE_DESCRIPTION = 'Описание: ',
  WORKSPASE_DESCRIPTION_PLACEHOLDER = 'Добавить описание',
  BUTTON_OK = 'Сохранить',
  BUTTON_NO = 'Отмена',
  CHECK_FAVORITE_CHECK = 'избранная',
  CHECK_PRIVATE = 'личная',
  CHECK_CLOSE = 'закрыть',
  DELETE_BOARD = 'Вы уверены, что хотите удалить доску?',
  BUTTON_DELETE = 'Удалить',
  SAVED = 'Сохранено',
  SAVED_ERROR = 'Ошибка сохранения',
}

enum WorkspaceContentEn {
  WORKSPACE_TITLE = 'Untitled',
  BOARDS_TITLE = 'Boards',
  MEMBERS_TITLE = 'Members',
  BOARD_NAME = 'Board Name',
  BOARD_CREATE = 'Create board',
  BOARD_COLOR = 'Board colour',
  WORKSPACE_ERROR = 'Error',
  WORKSPACE_INVITE = 'Invite Workspace members',
  CREATE = 'Create',
  WORKSPACE_TITLES = 'Workspaces',
  WORKSPACE_CURRENT = 'Current',
  WORKSPACE_CREATE = 'Create Workspace',
  WORKSPACE_NAME = 'Workspace Name',
  WORKSPACE_COLOR = 'Board colour',
  UPDATE_WORKSPASE_TITLE = 'Settings Workspace ',
  UPDATE_WORKSPASE = 'Name',
  UPDATE_WORKSPASE_NAME = 'New name of Workspace',
  CHECK_FAVORITE = 'favorite',
  WORKSPASE_DESCRIPTION = 'Description: ',
  WORKSPASE_DESCRIPTION_PLACEHOLDER = 'Add description',
  BUTTON_OK = 'Save',
  BUTTON_NO = 'Cancel',
  CHECK_FAVORITE_CHECK = 'favorite',
  CHECK_PRIVATE = 'private',
  CHECK_CLOSE = 'close board',
  DELETE_BOARD = 'You are sure you want to remove the board?',
  BUTTON_DELETE = 'Delete',
  SAVED = 'Saved',
  SAVED_ERROR = 'Failed to save',
}

enum MeSettingsContentRu {
  SETTINGS_ME = 'Настройки',
  LOGOUT_ME = 'Выйти',
  SETTINGS_SAVED = 'Настройки сохранены.',
  SETTINGS_ERROR = 'Произошла ошибка.',
  NAME = 'Имя',
  COLOUR = 'Цвет',
  THEME = 'Тема',
  SAVE = 'Сохранить',
}

enum MeSettingsContentEn {
  SETTINGS_ME = 'Settings',
  LOGOUT_ME = 'Exit',
  SETTINGS_SAVED = 'Settings have been saved.',
  SETTINGS_ERROR = 'An error has occurred.',
  NAME = 'Name',
  COLOUR = 'Colour',
  THEME = 'theme',
  SAVE = 'Save',
}

enum BoardContentRu {
  ADD_TASK = 'Добавить карточку',
  ADD_LIST = 'Добавить список',
  ADD_LIST_TEXT = 'Добавьте еще одну колонку',
  INPUT_TITLE = 'Ввести заголовок для этой карточки',
  INPUT_LIST_NAME = 'Ввести заголовок списка',
  DELETE_LIST = 'Удалить список',
}

enum BoardContentEn {
  ADD_TASK = 'Add a card',
  ADD_LIST = 'Add a list',
  ADD_LIST_TEXT = 'Add a list',
  INPUT_TITLE = 'Enter a title of this card',
  INPUT_LIST_NAME = 'Enter a title of this list',
  DELETE_LIST = 'Delete a list',
}
enum BoardHeaderContentRu {
  UPDATE_BOARD_NAME = 'Изменить название доски',
  BOARD_SETTING = 'Настройки доски',
  UPDATE_BOARD_SETTING = 'Настройки',
  BOARD_TITLE = 'Доска:  ',
  BOARD_INVITE = 'Пригласить участников',
  DELETE_BOARD_NAME = 'Удалить доску',
  MEMBERS_TITLE = 'Пользователи',
  BUTTON_OK = 'Сохранить',
  BUTTON_NO = 'Отмена',
  CHECK_FAVORITE = 'избранная',
  CHECK_PRIVATE = 'личная',
  CHECK_CLOSE = 'закрыть',
  BOARD_DESCRIPTION = 'Описание: ',
}
enum BoardHeaderContentEn {
  UPDATE_BOARD_NAME = 'Settings name Board ',
  BOARD_SETTING = 'Settings Board',
  UPDATE_BOARD_SETTING = 'Settings',
  BOARD_TITLE = 'Board: ',
  BOARD_INVITE = 'Invite Board members',
  DELETE_BOARD_NAME = 'Delete Board',
  MEMBERS_TITLE = 'Members',
  BUTTON_OK = 'Save',
  BUTTON_NO = 'Cancel',
  CHECK_FAVORITE = 'favorite',
  CHECK_PRIVATE = 'private',
  CHECK_CLOSE = 'close board',
  BOARD_DESCRIPTION = 'description: ',
}

enum CardEditRu {
  CREATE_DATA = 'Создано',
  DESCRIPTION = 'Описание',
  DESCRIPTION_PLACEHOLDER = 'Добавить более подробное описание...',
  COLOR = 'Выбрать цвет обложки',
  COMMENTS_TITLE = 'Комментарии',
  COMMENT = 'Оставить комментарий',
  COMMENT_PLACEHOLDER = 'Напишите комментарий ...',
  DELETE = 'Удалить карточку',
  CHECKED = 'Выполнено',
  DATE_TO_COMPLETE = 'Выполнить до:',
}

enum CardEditEn {
  CREATE_DATA = 'Created',
  DESCRIPTION = 'Description',
  DESCRIPTION_PLACEHOLDER = 'Add a more detailed description...',
  COLOR = 'Choose the cover color',
  COMMENTS_TITLE = 'Comments',
  COMMENT = 'Leave a comment',
  COMMENT_PLACEHOLDER = 'Input comments ...',
  DELETE = 'Delete card',
  CHECKED = 'Done',
  DATE_TO_COMPLETE = 'Do before:',
}

enum WorkspaceMembersContentRu {
  ADD_MEMBERS = 'Добавить пользователя в пространство:',
  MEMBERS = 'Текущие пользователи',
  SAVED = 'Сохранено',
  ERROR = 'Ошибка сохранения',
  CLOSE = 'Закрыть'
}

enum WorkspaceMembersContentEn {
  ADD_MEMBERS = 'Add member to the workspace:',
  MEMBERS = 'Current members',
  SAVED = 'Saved',
  ERROR = 'Failed to save',
  CLOSE = 'Close'
}

let mainPageContent: any;
let MenuContent: any;
let LoginPageContent: any;
let SignUpPageContent: any;
let WorkspaceContent: any;
let MeSettingsContent: any;
let WorkspaceName: any;
let BoardContent: any;
let CardEdit: any;
let BoardHeaderContent: any;
let WorkspaceMembersContent: any;

function getLeng() {
  let leng = localStorage.getItem('leng') || 'Русский';
  mainPageContent = leng === 'English' ? MainPageContentEn : MainPageContentRu;
  MenuContent = leng === 'English' ? MenuContentEn : MenuContentRu;
  LoginPageContent =
    leng === 'English' ? LoginPageContentEN : LoginPageContentRu;
  SignUpPageContent =
    leng === 'English' ? SignUpPageContentEn : SignUpPageContentRu;
  WorkspaceContent =
    leng === 'English' ? WorkspaceContentEn : WorkspaceContentRu;
  MeSettingsContent =
    leng === 'English' ? MeSettingsContentEn : MeSettingsContentRu;
  WorkspaceName =
    leng === 'English' ? MenuContentEn.MENU_TITLE : MenuContentRu.MENU_TITLE;
  BoardContent = leng === 'English' ? BoardContentEn : BoardContentRu;
  CardEdit = leng === 'English' ? CardEditEn : CardEditRu;
  BoardHeaderContent =
    leng === 'English' ? BoardHeaderContentEn : BoardHeaderContentRu;
  WorkspaceMembersContent =
    leng === 'English' ? WorkspaceMembersContentEn : WorkspaceMembersContentRu;
}

getLeng();

export {
  mainPageContent,
  MenuContent,
  LoginPageContent,
  SignUpPageContent,
  WorkspaceContent,
  MeSettingsContent,
  WorkspaceName,
  BoardContent,
  CardEdit,
  BoardHeaderContent,
  WorkspaceMembersContent,
};
